import { useTranslation } from 'react-i18next';

import awsBadge from '../../../../assets/icons/amazonwebservices.svg';
import isoBadge from '../../../../assets/icons/attaima-website-iso.svg';
import soc2Badge from '../../../../assets/images/attaima-website-soc-2.png';

import styles from './sass/FooterLogos.module.scss';

const COMPLIANCE_ITEMS = [
  { slot: 'AWS', src: awsBadge, labelKey: 'complianceAws' as const },
  { slot: 'SOC2', src: soc2Badge, labelKey: 'complianceSoc2' as const },
  { slot: 'ISO27001', src: isoBadge, labelKey: 'complianceIso27001' as const },
] as const;

function FooterLogos() {
  const { t } = useTranslation();

  return (
    <div className={styles.root} role="presentation">
      {COMPLIANCE_ITEMS.map(({ slot, src, labelKey }) => {
        const label = t(`login.${labelKey}`);
        return (
          <div key={slot} className={styles.item} title={label}>
            <img
              className={styles.logo}
              src={src}
              alt={label}
              loading="lazy"
              decoding="async"
            />
          </div>
        );
      })}
    </div>
  );
}

export default FooterLogos;
